import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Grid2 as Grid, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import SectionCard from '../../components/SectionCard';
import { changeInterfaceLanguage, languages, t } from '../../i18n';

export default function Settings() {
    const { i18n } = useTranslation();
    const [notice, setNotice] = useState(null);
    const [busy, setBusy] = useState(false);
    const handleLanguage = async (event) => {
        setBusy(true);
        setNotice(null);
        try {
            await changeInterfaceLanguage(event.target.value);
            setNotice({ severity: 'success', text: 'O idioma da plataforma foi atualizado.' });
        } catch {
            setNotice({ severity: 'error', text: 'Não foi possível alterar o idioma. Tente novamente.' });
        } finally {
            setBusy(false);
        }
    };
    return (
        <Box sx={{ maxWidth: 1280, mx: 'auto' }}>
            <Paper variant="outlined" sx={{ p: { xs: 2.5, md: 3 }, mb: 3, borderRadius: 3 }}>
                <Stack direction="row" spacing={2.5} alignItems="center">
                    <Box>
                        <Typography variant="h2" component="h2" sx={{ color: 'primary.main' }}>{t('Preferências da plataforma')}</Typography>
                        <Typography color="text.secondary" sx={{ mt: 0.75 }}>{t('Adapte a interface às suas preferências.')}</Typography>
                    </Box>
                </Stack>
            </Paper>
            <SectionCard title={t('Idioma da plataforma')} description={t('Escolha o idioma utilizado nos menus e nas páginas.')}>
                <Grid container spacing={2.5}>
                    <Grid size={{ xs: 12, sm: 6, lg: 5 }}>
                        <TextField
                            select fullWidth label={t('Idioma')} value={i18n.resolvedLanguage || 'pt'}
                            onChange={handleLanguage} disabled={busy}
                            helperText={t('A alteração é aplicada de imediato e fica guardada neste navegador.')}
                        >
                            {languages.map((language) => <MenuItem key={language.value} value={language.value}>{language.label}</MenuItem>)}
                        </TextField>
                    </Grid>
                </Grid>
                {notice && <Alert severity={notice.severity} sx={{ mt: 2.5 }}>{t(notice.text)}</Alert>}
            </SectionCard>
        </Box>
    );
}
